import React, { useState } from 'react';
import {
  LocationDTO,
  UpdateLocationDTO,
} from '@peartherapeutics/weaver-api-client';

import { WeaverApiClientInstance } from 'api/weaverApiClientInstance';
import ErrorInterceptor from 'components/common/ErrorInterceptor';
import EditLocation from './EditLocation';
import DisplayLocation from './DisplayLocation';
import './styles.scss';

export interface IRowProps {
  location: LocationDTO;
  isLocationWrite: boolean;
}

export const updateLocationSuccessMessage = 'Location was updated successfully';

export const Row = (props: IRowProps) => {
  const [locationData, setlocationData] = useState<LocationDTO>(props.location);
  const [isEditing, setEditing] = useState<Boolean>(false);

  const cancelEdit = () => {
    setEditing(false);
  };

  const handleSaveLocation = async (data: UpdateLocationDTO) => {
    let updatedLocation: Nullable<LocationDTO>;
    try {
      const response = await WeaverApiClientInstance.updateLocation({
        ...locationData,
        ...data,
      });
      updatedLocation = response.data;
    } catch (e) {
      updatedLocation = null;
      const errors = e.errors.map((m: any) => ({ message: m.detail }));
      ErrorInterceptor.error({ errors });
    }

    if (updatedLocation) {
      ErrorInterceptor.success(updateLocationSuccessMessage, true);
      setlocationData(updatedLocation);
      setEditing(false);
    }
  };

  return isEditing ? (
    <EditLocation
      location={locationData}
      onClickCancel={cancelEdit}
      onSaveLocation={handleSaveLocation}
    />
  ) : (
    <DisplayLocation
      isLocationWrite={props.isLocationWrite}
      location={locationData}
      onClickEditLocation={() => setEditing(true)}
    />
  );
};

export default Row;
